import { Component, OnInit, ViewChild } from '@angular/core';
import { Membership } from '../../../../common/models/membership';
import { OrganisationService } from '../organisation.service';
import { UtilitiesService } from '../../../../common/shared/services/utilities.service';
import { StatusEnum, MemberCategoryEnum, MembershipStatusReasonEnum, OrganisationCategoryEnum } from '../../../../common/helper/enums';
import { OrganisationFormComponent } from '../organisation-form/organisation-form.component';
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../../../common/shared/services/dialog.service';
import { AbstractFormGroupDirective } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../components/layout/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-organisation-view',
  templateUrl: './organisation-view.component.html',
  styleUrls: ['./organisation-view.component.scss']
})
export class OrganisationViewComponent implements OnInit {

  membershipsDataSource: MatTableDataSource<Membership>;
  displayedColumnsMemberships: string[] = [
    'organisationName', 'statusReason', 'Actions'];

  mainOrganisationId: string;

  StatusEnum: typeof StatusEnum = StatusEnum;
  MemberCategoryEnum: typeof MemberCategoryEnum = MemberCategoryEnum;
  MembershipStatusReasonEnum: typeof MembershipStatusReasonEnum = MembershipStatusReasonEnum;
  OrganisationCategoryEnum: typeof OrganisationCategoryEnum = OrganisationCategoryEnum;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private _matDialog: MatDialog,
    private _organisationservice: OrganisationService,
    private _utilitiesService: UtilitiesService,
    private _translateService: TranslateService,
    private _dialogService: DialogService) { }

  ngOnInit() {
    this.membershipsDataSource = new MatTableDataSource<Membership>();
    this.membershipsDataSource.paginator = this.paginator;

    this._utilitiesService.addMinorAction('LoadMemberships');
    this.loadMemberships();

    if (this._utilitiesService.wasOrgPreChoosen()) {
      this.addMembership();
    }

    this._organisationservice.loadMainOrganisationsId().subscribe(
      data => {
        this.mainOrganisationId = this._utilitiesService.getData(data);
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  private loadMemberships() {
    this._organisationservice.loadMemberships().subscribe(
      data => {
        this.membershipsDataSource.data = this._utilitiesService.getData(data);
        this.membershipsDataSource.data = this.membershipsDataSource.data.filter(membership => this.membershipStatusInactive(membership.id) === false);
        
        this._utilitiesService.removeAction('LoadMemberships');
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  cancelMembership(membershipId: string) {
    this._utilitiesService.addMinorAction('CancelMembership');
    this._utilitiesService.addMinorAction('CancelMembership-' + membershipId);
    this._organisationservice.cancelMemberships(membershipId).subscribe(
      data => {
        if (this._utilitiesService.getData(data)) {
          this._translateService.get(['portal.Profile.Organisation.Cancel.Success']).subscribe((res: string) => {
            this._dialogService.showSuccessDialog(res['portal.Profile.Organisation.Cancel.Success']);
          });
          this.loadMemberships();
        }
        this._utilitiesService.removeAction('CancelMembership');
        this._utilitiesService.removeAction('CancelMembership-' + membershipId);
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  addMembership() {
    const dialogRef = this._matDialog.open(OrganisationFormComponent, {
      width: environment.MatDilalogWidth,
      data: this.membershipsDataSource.data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Success') {
        this.loadMemberships();
        this._translateService.get(['portal.Profile.Organisation.Create.Success']).subscribe((res: string) => {
          this._dialogService.showSuccessDialog(res['portal.Profile.Organisation.Create.Success']);
        });
      } else if (result === 'Error') {
        this._translateService.get(['portal.Profile.Organisation.Create.Error']).subscribe((res: string) => {
          this._dialogService.showErrorDialogWithBody(res['portal.Profile.Organisation.Create.Error']);
        });
      }
    });
  }

  loadMembershipsActive() {
    return this._utilitiesService.isActionActive('LoadMemberships');
  }

  cancelSomeMembershipActive() {
    return this._utilitiesService.isActionActive('CancelMembership');
  }

  cancelMembershipActive(membershipId: string) {
    return this._utilitiesService.isActionActive('CancelMembership-' + membershipId);
  }

  isMainMembership(membershipId: string) {
    const tmpMembership = this.membershipsDataSource.data.find(
      x => x.id === membershipId && x.organisationId === this.mainOrganisationId
    );

    if (tmpMembership !== null && tmpMembership !== undefined) {
      return true;
    }

    return false;
  }

  membershipStatusInactive(membershipId: string) {
    const tmpMembership = this.membershipsDataSource.data.find(
      x => x.id === membershipId && x.status === this.StatusEnum.Inactive
    );

    if (tmpMembership !== null && tmpMembership !== undefined) {
      return true;
    }

    return false;
  }

  showTable() {
    return (this.membershipsDataSource &&
            this.membershipsDataSource.data &&
            this.membershipsDataSource.data.length > 0 &&
            !this._utilitiesService.isActionActive('LoadMemberships'));
  }

  confirmDialog(membershipId: string) {
    this._translateService.get(['portal.Profile.Organisation.Confirm.Title', 'portal.Profile.Organisation.Confirm.Text'])
    .subscribe((res: string) => {
      const confirmDialog = this._matDialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: {
          title: res['portal.Profile.Organisation.Confirm.Title'],
          message: res['portal.Profile.Organisation.Confirm.Text']
        }
      });
      confirmDialog.afterClosed().subscribe(result => {
        if (result === true) {
          this.cancelMembership(membershipId);
        }
      });
    });
  }
}
